import React from 'react'

import StructuredTextReport from '../../../structured-text-report/structured-text-report'

import ChartLine from './line'
import DataTable from './table'
import ChartBarPlot from './bar-plot'
import ChartBarScatterVertical from './bar-scatter-vertical'
import ChartBarScatter from './bar-scatter'

import { useInView } from 'react-intersection-observer'

import * as style from './data-slide.module.scss'

const DynamicChart = ({ type, ...props }) => {
  switch (type) {
    case 'line':
      return <ChartLine {...props} />
    case 'barPlot':
      return <ChartBarPlot {...props} />
    case 'barScatter':
      return <ChartBarScatter {...props} />
    case 'barScatterVertical':
      return <ChartBarScatterVertical {...props} />
    default:
      return null
  }
}

const DataSlide = ({ slide, customIndex }) => {
  const { ref, inView } = useInView({
    threshold: 0.7,
    triggerOnce: true
  })

  let { dataType, data, variant = 'horizontal', content, preContent } = slide

  const isHorizontal = variant === 'horizontal'

  data = JSON.parse(data)

  const renderContent = (dataType, data, variant) => {
    if (dataType === 'table') {
      return (
        <div
          className={style.wrapperTable}
          ref={ref}
          data-keen-slider-clickable
        >
          <DataTable {...data} variant={variant} inView={inView} />
        </div>
      )
    }

    if (Array.isArray(data)) {
      return data.map((d, index) => {
        return (
          <div
            className={style.wrapperChart}
            ref={ref}
            key={`graph-${d?.title ?? index}`}
          >
            <DynamicChart
              key={'graph' + index}
              type={d?.type}
              variant={variant}
              inView={inView}
              {...d}
            />
          </div>
        )
      })
    }

    return (
      <div className={style.wrapperChart} ref={ref}>
        <DynamicChart
          type={data?.type}
          variant={variant}
          inView={inView}
          {...data}
        />
      </div>
    )
  }

  if (isHorizontal) {
    return (
      <>
        <div className="col-12">
          {slide.isContinued ? null : (
            <span className={`tag`}>Insight 0{customIndex}</span>
          )}

          <h3 className={`text-base-000 h300 m-0 ${style.title}`}>
            {slide.title}
          </h3>
        </div>

        {content && (
          <div className="col-12 col-lg-6">
            <StructuredTextReport content={content} />
          </div>
        )}
        {preContent && (
          <div className="col-12 col-lg-6">
            <StructuredTextReport content={preContent} />
          </div>
        )}
        <div className={`col-12 ${style.wrapperHorizontal}`}>
          {renderContent(dataType, data, variant)}
        </div>
      </>
    )
  }

  return (
    <>
      <div className="col-12 col-lg-5">
        {slide.isContinued ? null : (
          <span className={`tag`}>Insight 0{customIndex}</span>
        )}

        <h3 className={`text-base-000 h300 m-0`}>{slide.title}</h3>
        {content && <StructuredTextReport content={content} />}
      </div>
      <div
        className={[
          'col-12',
          'col-lg-6',
          'offset-lg-1',
          style.wrapperVertical
        ].join(' ')}
      >
        {renderContent(dataType, data, variant)}
      </div>
    </>
  )
}

export default DataSlide
